import api from "./api";

const SupportCaseAPI = {
    getCaseDetails: (params) => api.get(`/support-cases/user/support-case-details?${params}`),
    getPendingCase: () => api.get(`/admin/support-cases/pending-case`),
    getChattingCase: () => api.get(`/admin/support-cases/chatting-case`),
    getCaseChatBySession: (caseSessionId) => api.get(`/admin/support-cases/case-chat/session/${caseSessionId}`),
    insert: (params) => api.post(`/admin/support-cases/insert`, params),
    accept: (id) => api.post(`/admin/support-cases/accept/${id}`),
    getCurrentSupporter: () => api.get(`/admin/support-cases/current-supporter`),
    reject: (params) => api.post(`/admin/support-cases/reject`, params),
    insertCaseFile: (params) => api.post(`/admin/support-cases/case-files/insert`, params),
    resolved: (id) => api.put(`/admin/support-cases/resolved/${id}`),
    getCaseFileByCaseSession: (params) => api.get(`/admin/support-cases/case-files/case-session?${params}`),
    
    // New SupportTicket endpoints
    getAdminTickets: () => api.get(`/user/support/admin/tickets/paged?PageNumber=1&PageSize=100`),
    getTicketMessages: (ticketId) => api.get(`/user/support/tickets/${ticketId}/messages`),
    deleteAdminTicket: (ticketId) => api.delete(`/user/support/admin/tickets/${ticketId}`),
};

export default SupportCaseAPI;
